module.exports = __webpack_public_path__ + "static/media/image15.38d24315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image15.jpg
// module id = 1079
// module chunks = 0